import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ManageSeoPages from './ManageSeoPages';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'SEO Pages | Admin',
    component: (
      <AdminLayout>
        <ManageSeoPages />
      </AdminLayout>
    ),
  };
}

export default action;
